import { useFormContext } from 'react-hook-form';
import Grid from '@mui/material/Grid';

import { useLoadData } from '../../../hooks/useLoadData';
import { ApiResponse } from '../../../models/api-response';
import { countyApiKeyStore } from '../../../api/county-api-key-store';
import { FormInput } from '../../../components/hook-form/form-input.component';
import { marketAreaApiKeyStore } from '../../../api/masters/market-area-api-key-store';
import { FormAutoCompleteMultiSelectDynamic } from '../../../components/hook-form/form-autocomplete-multi-select.dynamic.component';

export const MarketAreaForm = () => {
  const { setValue, getValues } = useFormContext();
  const marketAreaID = getValues('marketAreaID');
  const { data, isLoading } = useLoadData<ApiResponse<any>>(marketAreaApiKeyStore.getMarketAreaById(marketAreaID));

  if (data) {
    setValue('counties', data?.data?.counties);
  }

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item lg={12} sm={12} xl={12} xs={12}>
          <FormInput label="Market Area Name" name="marketAreaName" maxLength={150} multiline={false} autoFocus />
        </Grid>
        <Grid item lg={12} sm={12} xl={12} xs={12}>
          <FormAutoCompleteMultiSelectDynamic
            name="counties"
            label="Counties"
            getQueryKeyConfig={() => countyApiKeyStore.getCounties()}
            optionsLabelKey="countyName"
            optionsValueKey="countyID"
          />
        </Grid>
      </Grid>
    </div>
  );
};
